import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";

const PickRfqColumnsModal = ({ onRfqSelectColumns, initialRfqSelectedColumns = ['Buyer / Seller','Company Name','Preferred Source Country','Wanted','Mobile No','Short Description'], onRfqClose }) => {
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const columns = [
        'Buyer / Seller', 'Company Name', 'Preferred Source Country', 'Wanted', 
        'Mobile No', 'Short Description', 'Product HSN Code', 'Quantity', 'Unit', 
        'Destination Port', 'Income Term', 'Payment Term', 'Target Price', 
        'Negotiable', 'Attachment'
    ];

    // ✅ Filter columns based on search term
    const filteredColumns = columns.filter(column =>
        column.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // ✅ Handle column selection
    const handleCheckboxChange = (column) => {
        setSelectedColumns((prev) =>
            prev.includes(column)
                ? prev.filter((item) => item !== column)
                : [...prev, column]
        );
    };

    // ✅ Handle "Select All" functionality
    const handleSelectAll = () => {
        if (selectedColumns.length === filteredColumns.length) {
            setSelectedColumns([]);
        } else {
            setSelectedColumns(filteredColumns);
        }
    };

    // ✅ Handle submit
    const handleSubmit = () => {
        onRfqSelectColumns(selectedColumns);
        onRfqClose();
    };

    useEffect(() => {
        setSelectedColumns(initialRfqSelectedColumns);
    }, []);

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 md:w-1/3 p-6 shadow-lg">
                {/* Modal Header */}
                <div className="flex justify-between items-center border-b border-gray-300 pb-3">
                    <h2 className="text-lg font-semibold">Pick Columns</h2>
                    <button onClick={onRfqClose} className="text-gray-500 hover:text-gray-700">
                        ✕
                    </button>
                </div>

                {/* Search Bar */}
                <div className="flex justify-between items-center p-4">
                    <div className="relative w-2/3">
                        <input
                            type="text"
                            placeholder="Search columns..."
                            className="rounded-md px-4 py-2 w-full bg-blue-100 outline-blue-100"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <FaSearch className="absolute right-3 top-3 text-gray-500" />
                    </div>
                    <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-blue-500 scale-125 cursor-pointer"
                        checked={selectedColumns.length === filteredColumns.length && filteredColumns.length > 0}
                        onChange={handleSelectAll}
                    />
                </div>

                {/* Column List */}
                <div className="max-h-80 overflow-y-auto py-2">
                    {filteredColumns.length > 0 ? (
                        filteredColumns.map((column) => (
                            <div key={column} className="flex items-center gap-3 cursor-pointer p-2">
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-blue-500 scale-125"
                                    checked={selectedColumns.includes(column)}
                                    onChange={() => handleCheckboxChange(column)}
                                />
                                <span>{column}</span>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 text-sm text-center py-2">
                            No matching columns found.
                        </p>
                    )}
                </div>

                {/* Submit Button */}
                <div className="flex items-center justify-end p-2">
                    <button
                        onClick={handleSubmit}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PickRfqColumnsModal;